<template>

  <v-row>
    <v-col cols="12">
      <ServerSideResult :test="done" />
    </v-col>
  </v-row>

</template>

<script>
import lookups from '@/mixins/lookups';

import ServerSideResult from "@/components/ServerSideResult";

export default {

  components: { ServerSideResult },

  props: {
    customer: {
      type: Object,
      required: true,
    },
    topup: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      done: undefined
    }
  },

  watch: {
    done(to) {
      if (to) {
        this.$emit('done', to);
      }
    }
  },

  mounted() {
    this.remoteLookup('ultimate_tz_check_me_back_disbursed', { uuid: this.customer.uuid }).then( done => this.done = done ).catch(e => this.done = null);
  },

  mixins: [lookups],

}
</script>
